import React from 'react';
import Layout from './containers/Layout/Layout';

const App = () => <Layout />;

export default App;
